const TOKEN_MAP = {
  xs: "var(--space-1)",
  sm: "var(--space-2)",
  md: "var(--space-4)",
  lg: "var(--space-8)",
  xl: "var(--space-12)",
  "2xl": "var(--space-16)",
  "3xl": "var(--space-24)",
};

const STEPS = [0, 1, 2, 3, 4, 5, 6, 8, 10, 12, 16, 24];

const SCALE_MAP = Object.fromEntries(
  STEPS.map((step) => [step, `var(--space-${step})`]),
);

const PX_PER_STEP = 4;
const PX_PER_REM = 16;
const LENGTH = /^(\d*\.?\d+)(rem|px)$/;

const pixels = ([, amount, unit]) =>
  Number(amount) * (unit === "rem" ? PX_PER_REM : 1);

const isOnStep = (length) => {
  const match = length.match(LENGTH);
  const px = match ? pixels(match) : 0;
  return px > 0 && STEPS.includes(px / PX_PER_STEP);
};

export const onStepLengths = (value) =>
  value.includes("calc(") ? [] : value.split(/\s+/).filter(isOnStep);

const resolveSpacing = (value) =>
  value == null
    ? undefined
    : TOKEN_MAP[value] ?? SCALE_MAP[value] ?? String(value);

export default resolveSpacing;
